import {createContext, useContext} from "react";
import { TypeIniciative } from "src/components/ModalIniciatives/interface";
import { IMetba003 } from "../Objectives/interface";
import { IMetba002 } from "../Perspective/interface";

interface IMapContextProvider{
    mapId: number;
    updatingPercentage: boolean;
    inEditCauseEffect: boolean;
    showCauseEffect: boolean;
    permissions: number;
    onMouseOverObjective: (objective: IMetba003) => void;
    onMouseOutObjective: () => void;
    onCallbackRelateEffect: (objective: IMetba003)=>void;
    onCallbackDeleteCauseEffect: (objectiveId: number, causeEffectId: number) => void;
    onCallbackDeletePerspective: (id: number, name: string) => void;
    onCallbackDeleteObjective: (id: number, name: string, perspectiveName: string) => void;
    openModalPerspective?: (perspective?: IMetba002) => void;
    openModalObjective?: (perspective: IMetba002, objective?: IMetba003) => void;
    openModalListIniciatives?: (typeIniciative: TypeIniciative, subTitle: string, onCallback?: (() => void) | undefined, permissions?: number | undefined) => void;
}

export const MapContextProvider = createContext<IMapContextProvider>({} as IMapContextProvider);

export function useMap(): IMapContextProvider{
	const context = useContext(MapContextProvider);

	if(!context){
		throw new Error("useMap function must be used inside the MapContext Provider.");
	}

	return context;
}
